import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.05556 10L6.51388 9.02498C6.50481 9.00865 6.49135 8.99519 6.47502 8.98612L2.19165 6.60647C2.11671 6.56484 2.12547 6.45438 2.20604 6.42508L12.7829 2.57894C12.8652 2.54901 12.9435 2.63182 12.909 2.71231L11.5 6"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <path
            clipRule="evenodd"
            d="M8.5 6.5C8.77614 6.5 9 6.72386 9 7V7.37015C9.4285 7.13435 9.92101 7 10.4445 7C12.1014 7 13.4445 8.34315 13.4445 10C13.4445 11.6569 12.1014 13 10.4445 13C9.62036 13 8.87302 12.6671 8.33131 12.1295C8.13531 11.9349 8.1341 11.6184 8.32862 11.4224C8.52313 11.2264 8.83971 11.2251 9.03572 11.4197C9.39775 11.7789 9.89482 12 10.4445 12C11.5491 12 12.4445 11.1046 12.4445 10C12.4445 8.89544 11.5491 8 10.4445 8C9.89482 8 9.39775 8.22109 9.03572 8.58037C9.01935 8.59661 9.00215 8.61149 8.98425 8.625C8.92874 8.84065 8.73298 9 8.5 9C8.22386 9 8 8.77614 8 8.5V7C8 6.72386 8.22386 6.5 8.5 6.5ZM10.8195 9.16668C10.8195 8.95957 10.6516 8.79168 10.4445 8.79168C10.2374 8.79168 10.0695 8.95957 10.0695 9.16668V10.1778C10.0695 10.4401 10.2821 10.6528 10.5445 10.6528H11.2778C11.4849 10.6528 11.6528 10.4849 11.6528 10.2778C11.6528 10.0707 11.4849 9.9028 11.2778 9.9028H10.8195V9.16668Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
